// AUTO-GENERATED by tools/generate-world1.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world1.mjs
import type { LevelDef } from '@tessera/engine';

export const WORLD_1_GENERATED: LevelDef[] = [
  // d*=2  branching=15.87  D=0.124
  {
    id: 'w1-l05',
    world: 1,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 4 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=3  branching=15.53  D=0.178
  {
    id: 'w1-l06',
    world: 1,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: 2, r: 0 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=4  branching=17.55  D=0.307
  {
    id: 'w1-l07',
    world: 1,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 0, r: 0 }, color: 0 },
    { coord: { q: -2, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    ],
  },
  // d*=4  branching=21.20  D=0.346
  {
    id: 'w1-l08',
    world: 1,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: 0 }, color: 0 },
    ],
  },
  // d*=5  branching=14.88  D=0.288
  {
    id: 'w1-l09',
    world: 1,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 1, r: 0 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    ],
  },
  // d*=5  branching=17.92  D=0.320
  {
    id: 'w1-l10',
    world: 1,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 0 },
    ],
  },
];
